var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lottie-player',{key:_vm.animationData,staticClass:"animation-lottie",attrs:{"src":_vm.animationData,"autoplay":"","loop":_vm.loop,"mode":"normal"}}),_c('p',{staticClass:"pt-1 has-text-dark"},[_vm._v(_vm._s(_vm.txtMsj))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }